import {Component, OnInit} from '@angular/core';

import {Router, ActivatedRoute} from '@angular/router';

import {HttpService} from '../services/HttpService';
import {NotificationService} from '../services/NotificationService';

import {AppComponent} from '../app.component';

@Component({
    selector: 'app-change-password',
    templateUrl: './change-password.component.html',
    styleUrls: ['./change-password.component.scss'],
    providers: [HttpService, NotificationService]
})
export class ChangePasswordComponent implements OnInit {

    public passwordDetails = {
        password: '',
        cpassword: '',
    }

    public resetToken: string;

    public showSuccess = false;

    public userData: any = {
        name: ''
    };

    constructor(
        private route: ActivatedRoute,
        public http: HttpService,
        public notify: NotificationService,
        public app: AppComponent,
        public router: Router
    ) {
        this.resetToken = route.snapshot.params['reset_token'];
    }

    ngOnInit() {
        this.app.loading = true;
        this.http.makeRequestPost(['app/user/get_reset_password_data', {reset_token: this.resetToken}])
        .subscribe(
            (resp) => {
                this.app.loading = false;
                if (resp.data) {
                    this.userData = resp.data;
                } else {
                    this.router.navigate(['/pages/login']);
                    this.notify.showNotification('Could not get your password reset data', 'Error', 'error');
                }


            }, (error) => {
                this.app.loading = false;
                this.router.navigate(['/pages/login']);
                this.notify.showNotification('Could not get your password reset data', 'Error', 'error');
            }
        )
    }

    updatePassword() {
        this.app.loading = true;
        this.http.makeRequestPost(['app/user/update_password', {password: this.passwordDetails.password, id: this.userData.id}])
        .subscribe(
            (resp) => {
                this.app.loading = false;
                if (resp.data) {
                    if (resp.data.length == undefined) {
                        this.notify.showNotification('Your password has been updated', 'Success', 'success');
                        this.userData = [];
                        this.showSuccess = true;

                    } else {
                        this.notify.showNotification('Could not reset your password', 'Error', 'error');
                    }
                } else {
                    this.notify.showNotification('Could not reset your password', 'Error', 'error');
                }
            },
            (error) => {
                this.app.loading = false;
                this.notify.showNotification('Could not reset your password', 'Error', 'error');
            }
        )
    }

}



// WEBPACK FOOTER //
// ./src/app/change-password/change-password.component.ts